import { useState, useEffect } from "react";
import {
  Grid,
  Box,
  Typography,
  Stack,
  TextField,
  Skeleton,
} from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";
import { useQuery } from "@apollo/client";

import {
  GET_DASHBOARD_STOCK_INFO,
  GET_DASHBOARD_TOTAL_ITEM,
} from "../Schema/Dashboard";
import DashboardStockChart from "../Components/Dashboard/DashboardStockChart";
import "./dashboard.scss";
import { currencyFormat } from "../Function/DynamicFn";
import warehouseIcon from "../Assets/DashboardIcons/warehouse.png";
import stockInIcon from "../Assets/DashboardIcons/back-in-store.png";
import stockOutIcon from "../Assets/DashboardIcons/out-of-the-box.png";
import supplierIcon from "../Assets/DashboardIcons/supplier.png";
import totalItemsIcon from "../Assets/DashboardIcons/total_items.png";
import totalBookIcon from "../Assets/DashboardIcons/book-total.png";
import totalUniformIcon from "../Assets/DashboardIcons/uniform-total.png";
import CardNewStudent from "../Components/Dashboard/CardNewStudent";

export const dashboardCards = [
  {
    title: "ចូលស្តុក",
    bgColor: "#5ca33a",
    qtyKey: "totalStockInQty",
    amountKey: "totalStockInAmount",
    icon: stockInIcon,
  },
  {
    title: "ចេញស្តុក",
    bgColor: "#e1505d",
    qtyKey: "totalStockOutQty",
    amountKey: "totalStockOutAmount",
    icon: stockOutIcon,
  },
  {
    title: "នៅសល់",
    bgColor: "#feb019",
    qtyKey: "totalRemainInStockQty",
    amountKey: "totalRemainInStockAmount",
    icon: warehouseIcon,
  },
];

const totalCardColor = [
  { color: "#5ca33a", icon: totalUniformIcon },
  { color: "#e1505d", icon: totalBookIcon },
  { color: "#feb019", icon: totalItemsIcon },
];

export default function Dashboard() {
  const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
  // const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const [dashboardInfo, setDashboardInfo] = useState(null);
  const [totalItem, setTotalItem] = useState([]);

  const handleStartDateChange = (date) => {
    setStartDate(date);
    // if (date && endDate && date > endDate) {
    //    setEndDate(null);
    // }
  };

  const { loading: loadingTotal } = useQuery(GET_DASHBOARD_TOTAL_ITEM, {
    onCompleted: ({ getDashboardTotalItem }) => {
      setTotalItem(getDashboardTotalItem);
    },
    onError: (err) => {
      console.log("Error:: getDashboardTotalItem", err?.message);
    },
  });

  const { refetch, loading } = useQuery(GET_DASHBOARD_STOCK_INFO, {
    variables: {
      from: startDate
        ? moment(startDate).startOf("month").format("YYYY-MM-DD")
        : "",
      to: startDate
        ? moment(startDate).endOf("month").format("YYYY-MM-DD")
        : "",
    },
    onCompleted: ({ getDashboardStockInfo }) => {
      setDashboardInfo(getDashboardStockInfo);
      // setPaginationData(getMaterialPagination?.paginator);
      // setLoading(false);
      // console.log({ getDashboardStockInfo })
    },
    onError: (err) => {
      // setLoading(true);
      console.log("Error:: getDashboardStockInfo", err?.message);
    },
    // pollInterval: 1000,
  });

  useEffect(() => {
    refetch();
  }, []);

  return (
    <div className="page-container">
      <Stack direction="row" justifyContent="space-between">
        <Stack direction="row" spacing={2} className="page-header">
          <Stack direction="column" justifyContent="center">
            <Box className="slash" />
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Typography className="page-title">ទំព័រដើម</Typography>
          </Stack>
        </Stack>
        <Box sx={{ flexGrow: 1 }} />
        <Box sx={{ alignItems: "end" }}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              value={new Date(startDate)}
              views={["month", "year"]}
              onChange={handleStartDateChange}
              className="search-field"
              slotProps={{
                textField: {
                  size: "small",
                  fullWidth: true,
                },
              }}
              renderInput={(params) => (
                <TextField {...params} size="small" fullWidth />
              )}
            />
          </LocalizationProvider>
        </Box>
      </Stack>

      <Box className="dashboard-page">
        <Grid container spacing={2}>
          {dashboardCards.map((card, index) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
              <DashboardCard
                loading={loading}
                title={card.title}
                icon={card.icon}
                bgColor={card.bgColor}
                qty={currencyFormat(dashboardInfo?.[card.qtyKey]?.toFixed(2))}
                amount={currencyFormat(
                  dashboardInfo?.[card.amountKey]?.toFixed(2),
                )}
              />
            </Grid>
          ))}
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Stack
              className={`dashboard-info-card bg-sky-blue`}
              spacing={1}
              sx={{ backgroundImage: `url(${supplierIcon})` }}
            >
              <Typography className="title">អ្នកផ្គត់ផ្គង់</Typography>
              <Stack direction="row" justifyContent="space-between">
                <Stack spacing={0.5}>
                  <Typography className="page-title">ចំនួន</Typography>
                  {loading ? (
                    <Skeleton variant="text" width={80} />
                  ) : (
                    <Typography className="text-value">
                      {" "}
                      {dashboardInfo?.totalSupplierQty !== undefined
                        ? dashboardInfo?.totalSupplierQty
                        : "-"}{" "}
                      នាក់
                    </Typography>
                  )}
                </Stack>
              </Stack>
            </Stack>
          </Grid>

          {totalItem?.map((card, index) => (
            <Grid item xs={12} sm={12} md={6} lg={3} xl={3} key={card?._id}>
              <Stack
                className={`dashboard-info-card`}
                spacing={1}
                sx={{
                  backgroundImage: `url(${totalCardColor[index]?.icon})`,
                  backgroundColor: `${totalCardColor[index]?.color} !important`,
                }}
              >
                <Typography className="title">{card?.title}</Typography>
                <Stack direction="row" justifyContent="space-between">
                  <Stack spacing={0.5}>
                    <Typography className="page-title">ចំនួន</Typography>
                    <Typography className="text-value">
                      {card?.total || "-"}
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Grid>
          ))}

          <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
            <Stack
              className={`dashboard-info-card bg-sky-blue`}
              spacing={1}
              sx={{ backgroundImage: `url(${totalItemsIcon})` }}
            >
              <Typography className="title">សរុបសម្ភារៈ</Typography>
              <Stack direction="row" justifyContent="space-between">
                <Stack spacing={0.5}>
                  <Typography className="page-title">ចំនួន</Typography>
                  {loadingTotal ? (
                    <Skeleton variant="text" width={80} />
                  ) : (
                    <Typography className="text-value">
                      {totalItem?.reduce((a, b) => a + b?.total, 0)}
                    </Typography>
                  )}
                </Stack>
              </Stack>
            </Stack>
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={9} xl={12}>
            <CardNewStudent />
          </Grid>

          <Grid item xs={12}>
            <DashboardStockChart />
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}

const DashboardCard = ({ title, qty, amount, icon, bgColor, loading }) => {
  return (
    <Stack
      className={`dashboard-info-card`}
      spacing={1}
      sx={{
        backgroundImage: `url(${icon})`,
        backgroundColor: `${bgColor} !important`,
      }}
    >
      <Typography className="title">{title}</Typography>

      <Stack direction="row" justifyContent="space-between">
        <Stack spacing={0.5}>
          <Typography className="page-title">ចំនួន</Typography>
          {loading ? (
            <Skeleton variant="text" width={80} />
          ) : (
            <Typography className="text-value">
              {qty !== undefined ? qty : "-"}{" "}
            </Typography>
          )}
        </Stack>
        <Stack spacing={0.5}>
          <Typography className="page-title">តម្លៃសរុប</Typography>
          {loading ? (
            <Skeleton variant="text" width={100} />
          ) : (
            <Typography className="text-value">
              {amount !== undefined ? `$${amount}` : "-"}
            </Typography>
          )}
        </Stack>
      </Stack>
    </Stack>
  );
};
